import { LearnerMixTopic } from "@outschool/gql-backend-generated";
import { gql, useQuery } from "@outschool/ui-apollo";

import {
  DUMMY_DEFAULT_TOPICS,
  DefaultTopic,
  Topic,
  TopicFilter,
} from "./consts";

const LEARNER_MIX_TOPICS_QUERY = gql`
  query LearnerMixTopics {
    learnerMixTopics {
      uid
      title
      description
      attachmentUrl
    }
  }
`;

export default function useTopicsForFilter(filter: TopicFilter) {
  const { data, loading, error } = useQuery(LEARNER_MIX_TOPICS_QUERY, {
    skip: filter === TopicFilter.DefaultTopics,
  });
  const learnerMixTopics: Topic[] =
    data?.learnerMixTopics.map((topic: LearnerMixTopic) => ({
      ...topic,
      isDefault: false,
    })) || [];
  const defaultTopics: Topic[] = DUMMY_DEFAULT_TOPICS.map(
    (topic: DefaultTopic) => ({
      ...topic,
      isDefault: true,
    }),
  );

  switch (filter) {
    case TopicFilter.All:
      return {
        data: [...learnerMixTopics, ...defaultTopics],
        loading,
        error,
      };
    case TopicFilter.MyMix:
      return {
        data: learnerMixTopics,
        loading,
        error,
      };
    case TopicFilter.DefaultTopics:
      return {
        data: defaultTopics,
        loading: false,
        error: null,
      };
  }
}
